import dayjs from 'dayjs'
import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const startTimeValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const { startTime, endTime } = ctx.form.values
    if (isNil(startTime)) {
      return '开始时间不能为空'
    }
    if (dayjs(startTime).isBefore(dayjs())) {
      return '开始时间不能小于当前时间'
    }
    if (
      endTime &&
      (dayjs(startTime).isAfter(endTime) || dayjs(startTime).isSame(endTime))
    ) {
      return '开始时间必须小于结束时间'
    }
    return null
  }
}
